export enum VoucherHolderSelfRegistrationStep {
    Unknown = 0,
    PersonalInfo = 100,
    UploadConsent = 300,
    Complete = 400
}
